import { useQuery } from '@tanstack/react-query';
import { api } from '../api';
import { UserAPI } from '@shared/types/api';

/**
 * Hook to fetch active neighborhoods
 */
export function useNeighborhoods(eventDateId?: string, cityId?: string) {
  return useQuery({
    queryKey: ['neighborhoods', eventDateId, cityId],
    queryFn: async (): Promise<UserAPI.GetNeighborhoodsResponse> => {
      const params = new URLSearchParams();
      if (eventDateId) params.append('eventDate', eventDateId);
      if (cityId) params.append('cityId', cityId);
      return api.get(`/user/neighborhoods?${params.toString()}`);
    },
    enabled: !!eventDateId || !!cityId,
  });
}
